import useTspApiResource from "../../hooks/useTspApiResource";
import TspApiService from "../../api/tspApiService";

// GET /api/tsp/dashboard — real data, scoped server-side to the caller's own
// teams (or every team with oversight). Sections the caller lacks the
// permission for (journey map, media) arrive as `null`; the section
// components below render an empty state for that, never an error.
// Refreshed silently every minute and on tab focus, so the numbers stay current.
export const DASHBOARD_REFRESH_MS = 60000;

export default function useTspDashboardData() {
  const { data, loading, error, reload } = useTspApiResource(() => TspApiService.getDashboard(), [], { refreshMs: DASHBOARD_REFRESH_MS });
  return { data, loading, error, reload };
}
